export default __webpack_public_path__ + "static/media/SNS_college.e3c6d1fa.png";